/* template */
<template><div v-on="$listeners" :class='["mpx-root-view","host-_85ab43ae"]'><div :class='["toast-text-only-demo"]'><cube-button @_click="clickToast">Toast - text only</cube-button><cube-toast txt="纯文案" ref="__mpx_ref_toast__"></cube-toast></div></div></template>
/* styles */
/* json */
/* script */
<script>
  import { processComponentOption, getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  var wxsModules = {}
  global.currentModuleId = "_85ab43ae"
  global.currentSrcMode = "wx"
  global.currentInject = {"moduleId":"_85ab43ae"}
  /** script content **/
  require("./toast-text-only.mpx.js?isComponent&outputPath=components%2Ftoast-text-only85ab43ae%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./toast-text-only.mpx?ctorType=component&index=0&isComponent&lang=js&mpx&outputPath=components%2Ftoast-text-only85ab43ae%2Findex&type=script")

  export default processComponentOption({
    option: global.__mpxOptionsMap["_85ab43ae"],
    ctorType: "component",
    outputPath: "components/toast-text-only85ab43ae/index",
    pageConfig: {},
    // @ts-ignore
    componentsMap: {'cube-button':getComponent(require("../../../packages/mpx-cube-ui/src/components/button/index.mpx?isComponent&outputPath=components%2Findex7752a2b9%2Findex")),'cube-toast':getComponent(require("../../../packages/mpx-cube-ui/src/components/toast/index.mpx?isComponent&outputPath=components%2Findex7b472558%2Findex"))},
    componentGenerics: {},
    genericsInfo: undefined,
    wxsMixin: getWxsMixin(wxsModules),
    hasApp: true
  })
</script>